import { Module, MutationTree, GetterTree } from "vuex";
import { ReportTemplate } from "@/models";

export interface ReportTemplatesCacheState {
  slug: string | null;
  templates: ReportTemplate[];
}

export const state: ReportTemplatesCacheState = {
  slug: null,
  templates: [],
};

export const getters: GetterTree<ReportTemplatesCacheState, unknown> = {
  cachedTemplates:
    (state) =>
    (slug: string): ReportTemplate[] | null =>
      state.slug === slug ? state.templates : null,
};

export const mutations: MutationTree<ReportTemplatesCacheState> = {
  setCachedTemplates(
    state,
    payload: { slug: string; templates: ReportTemplate[] }
  ) {
    state.slug = payload.slug;
    state.templates = payload.templates;
  },

  invalidateTemplatesCache(state) {
    state.slug = null;
    state.templates = [];
  },
};

export const reportTemplatesCache: Module<ReportTemplatesCacheState, unknown> =
  {
    namespaced: true,
    state,
    getters,
    mutations,
  };
